module.exports = __webpack_public_path__ + "img/SKMJ_place9.fd2176f1.png";